import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import useAuth from '../../../hooks/useAuth';

const User = ({ index, userData }) => {
    const { user } = useAuth();
    const { _id, displayName, email, role } = userData;
    const userTypes = ["Customer", "Admin",];
    const [userType, setUserType] = useState(role);
    const remainingUserTypes = userTypes.filter(u => u !== role);

    const updateUserType = (e, email) => {
        const type = e.target.value;
        const user = { email, type };
        fetch('https://gentle-tor-99938.herokuapp.com/users/update-role', {
            method: 'PUT',
            headers: {
                'authorization': `Bearer ${localStorage.getItem('token')}`,
                'content-type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(async (data) => {
                console.log(data)
                if (data.modifiedCount > 0) {
                    await setUserType(type);
                    swal("User Role Changed Successfully", {
                        icon: "success",
                    });
                }
            })
    }


    return (
        <tr>
            <td className="d-none d-md-table-cell">{index + 1}</td>
            <td className="d-none d-md-table-cell">{displayName}</td>
            <td>{email}</td>
            {
                user.email === email
                    ?
                    <td title="You cannot change your user role">
                        <select disabled className="form-select" aria-label="Default select example" className={
                            userType === "Admin"
                                ?
                                "btn btn-success w-100"
                                :
                                "btn btn-warning w-100"
                        } >
                            <option selected>{role}</option>
                            {
                                remainingUserTypes.map(type => <option value={type}>{type}</option>)
                            }
                        </select>
                    </td>
                    :
                    <td>
                        <select className="form-select" aria-label="Default select example" className={
                            userType === "Admin"
                                ?
                                "btn btn-success w-100"
                                :
                                "btn btn-warning w-100"
                        } onChange={(e) => {
                            updateUserType(e, email);
                        }}
                        >
                            <option selected>{role}</option>
                            {
                                remainingUserTypes.map(type => <option value={type}>{type}</option>)
                            }
                        </select>
                    </td>
            }
        </tr>
    );
};

export default User;